import { finalize } from 'rxjs/operators';
import { Component, OnInit, ViewChild, Inject, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { PatientsService } from '../patients/patients.service';
import { PatientService } from './patient.service';
import { BaseService } from '../shared/base.service';
import { FormBuilder, Validators } from '@angular/forms';
import { BaseComponent } from '../shared/base.component';
import { AppService } from '../app.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { SymptomMapComponent } from './symptom-map/symptom-map.component';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';
import { HELP_DI_MAP, HELP_SE_MAP } from '../shared/constants/help-buttons';
import { Subscription } from 'rxjs';
import { PopoverService } from '../shared/popover/popover.service';
import {ModalDirective} from 'ngx-bootstrap/modal';
import { QuestionnairesService } from './questionnaires/questionnaires.service';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { PatientQuestionnairesComponent } from './patient-questionnaires/patient-questionnaires.component';
import { ProposalDiagnogisComponent } from './proposal-diagnosis/proposal-diagnosis.component';
import { UsersService } from '../users/users.service';
import * as _ from 'lodash';
import { DocumentsService } from '../home/patient/document-dashboard/documents.service';
import { saveAs } from 'file-saver';
import { dragDisable } from 'd3';

@Component({
    selector: 'patient-component',
    templateUrl: 'patient.component.html',
    styleUrls: ['patient.component.scss'],
    providers: [
        PatientsService,
        BaseService,
        UsersService,
        DocumentsService
    ]
})

export class PatientComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
    doctors = [];
    assistants = [];
    mpa = [];
    patient = {
        diagnosisPatient: {}
    };

    questionnaires: any;
    questionnaireCount: number;
    triggerOpenProposalDiagnosis = false;
    diagnoses: any;
    selectedDiagnoses: any;
    loadDiagnoses = false;
    collapseDiagnoses = true;
    diagnosesAreDisabled = false;
    diagnosesBtnsAreHighlighted = false;
    createSE = false;
    initData = false;
    comparisonMode = false;

    diagnosesSub: Subscription;

    diCompletedDates = [];
    seCompletedDates = [];
    completedDates = [];

    id: number; // patient id
    activeQuestionnaireId: number;
    isViewOnly = false;

    userRole: any;

    canScroll = false;
    url = 'patient';

    successMessage: string = '';
    documentError: string = '';
    seType: string = '';

    dismissDiagnosis: boolean = false;

    age: number;
    dateFormat: string = 'DD.MM.YYYY';

    _noActiveQuestionnaire = false;
    selectedSEDate: string = '';
    selectedDIDate: string = '';
    updatePatientHeader = 'Update Patient';
    questionnaireData: any;
    selectedQuestionnaire : any;
    TABHEADER = this.patientService.PATIENTTABS;
    tabWithDiagnosis = [
        this.TABHEADER.OVERVIEW,
        this.TABHEADER.PROPOSALS,
        this.TABHEADER.THERAPY,
    ];
    isShowPatientDocument = false;
    isShowPatientServiceProvider = false;
    isShowPatientVideoCall = false;
    documents = [];
    pdf: any;
    getDiagnosisData = false;
    showArchiveMessageFuture = true;

    noActiveQuestionnaire() {
        const questionnaires = this.questionnaires || this.questionnairesComponent && this.questionnairesComponent.items;
        if (questionnaires && questionnaires instanceof Array && questionnaires.length) {
            return questionnaires.every(questionnaire => {
                let isArchive = questionnaire['archived'];
                if (questionnaire['di_questionnaire']) {
                    isArchive = isArchive && questionnaire['di_questionnaire']['archived'];
                    this.activeQuestionnaireId = !questionnaire['di_questionnaire']['archived'] ? questionnaire['di_questionnaire']['id'] : null;
                }
                this._noActiveQuestionnaire = isArchive;
                return isArchive;
            });
        }
        this._noActiveQuestionnaire = true;
        return true;
    }

    klDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd.mm.yyyy',
        disableSince: {year: null, month: null, day: null}
    };

    @ViewChild('tabs', {static: false}) tabs: TabsetComponent;
    @ViewChild('seMap', {static: false}) seMap: SymptomMapComponent;
    @ViewChild('diMap', {static: false}) diMap: SymptomMapComponent;
    @ViewChild('questionnairesComponent', {static: false}) questionnairesComponent: PatientQuestionnairesComponent;
    @ViewChild('modalArchive',  {static: false}) modalArchive: ModalDirective;
    @ViewChild('modalDiagnosis',  {static: false}) modalDiagnosis: ModalDirective;
    @ViewChild('diagnosisComponent', {static: false}) diagnosisComponent: ProposalDiagnogisComponent;

    // access control
    viewSymptomMap: boolean;
    sendQuestionnaire: boolean;

    selectedSymptomMap = 'SE';

    patientSub: Subscription;
    patientUpdateSub: Subscription;
    loadMapCompletedSub: Subscription;
    symptomMapActionSub: Subscription;
    paramsSubscription : Subscription;

    languages = [];
    tabSelected = 0;
    triggerOpenSRModal = false;
    haveNewData = false;

    constructor(public authService: AuthService,
                public router: Router,
                public baseService: BaseService,
                public appService: AppService,
                public route: ActivatedRoute,
                public formBuilder: FormBuilder,
                public patientService: PatientService,
                public popoverService: PopoverService,
                public questionnairesService: QuestionnairesService,
                public translateService: TranslateService,
                @Inject(DOCUMENT) private document: Document,
                public patientsService: PatientsService,
                public usersService: UsersService,
                public documentsService : DocumentsService) {
        super(authService, router, baseService, appService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.userRole = JSON.parse(localStorage.getItem('user'))['role_id'];
        this.showArchiveMessageFuture = JSON.parse(localStorage.getItem('user'))['show_confirm_archive_self_report_modal'];

        this.isUpdatable = this.authService.isAuthorised('patients.update');
        this.viewSymptomMap = this.authService.isAuthorised('patients.symptom-map');
        this.sendQuestionnaire = this.authService.isAuthorised('patient.send-questionnaire');
        this.document.body.classList.add('bg--white');
        this.patientService.activeTab = 1;
        this.appService.loadedProgressOfPatientList = 3;

        this.paramsSubscription = this.route.params.subscribe(params => {
            if (params.seType) {
                this.isLoading = true;
                this.seType = params.seType;
            }
            if (params.id) {
                this.id = params.id;
                this.loadData();
            }
            else{
                return this.router.navigate(['patients'], {
                    queryParams: {}
                });
            }
        });
        this.route.queryParams.subscribe(params => {
            this.params = params;

        });

        this.patientUpdateSub = this.appService.subscribe('updatePatient', data => {
            let patient = data.patient;
            if (patient.deleted_at != null || patient.archived == 1 || data.action == 'transfered') {
                let modalContent = this.translateService.instant('This patient was just ' + data.action + ' by {{executed_by}}', patient.latest_action.params);

                //Handle case transfer patient
                if (data.action === 'transfered') {
                    if (patient.assignee_id != null) {
                        modalContent = this.translateService.instant('This patient was just assigned to {{assigned_to}}', patient.latest_action.params);
                    } else {
                        modalContent = this.translateService.instant('This patient was just transfered to {{clinic_id}}', patient.latest_action.params);
                    }
                }

                let dialog = this.dialog.openAlert({
                    icon: 'fas fa-exclamation-triangle',
                    warning: true,
                    content: modalContent,
                    cancelText : 'OK',
                });

                dialog.onCancel(() => {
                    this.router.navigate(['patients']);
                });

                return;
            }

            if(this.patient['id'] == patient['id']) {
                if (this.modal.isShown && this.params['title'] == this.updatePatientHeader) {
                    return;
                }

                this.router.navigate([this.url + '/' + this.patient['id']]);

                this.modal.hide(); // Hide modal create se
                this.questionnairesComponent.modal.hide(); // Hide modal send reminder

                if (this.patientService.activeTab === this.TABHEADER.OVERVIEW) {
                    return this.loadData();
                }
                this.haveNewData = true;
                return;
            }
        });

        this.symptomMapActionSub = this.patientService.symptomMapAction.subscribe((value) => {
            if (value['action'] === this.patientService.ACTION.edit_mode) {

                if (value['type'] == 'DI' && this.diMap.initialSymptomMap) {
                    return this.selectTabHeader(this.TABHEADER.CV);
                }

                if (value['type'] == 'SE') {
                    this.selectTabHeader(this.TABHEADER.CV);
                }

                this.loadMapCompletedSub = this.diMap.loadMapCompleted.subscribe(() => {
                    this.selectTabHeader(this.TABHEADER.CV);
                    this.loadMapCompletedSub.unsubscribe();
                });
            }

            if (value['action'] === this.patientService.ACTION.cv_map) {
                return this.selectTabHeader(this.TABHEADER.CV);
            }

        });

        this.diagnosesSub = this.appService.subscribe('diagnoses', data => {
            const user = this.authService.user;
            var userSetting = user['settings'];

            if (data['selectedDiagnosesAreUpdated']
                && data['isProposal']
                &&user['clinic']['show_proposal_diagnosis'] == 1
                && !userSetting['diagnosis_pop_up_off']) {
                // show pop up
                // check user setting
                this.showDiagnosisModal();
            }

            if(this.patientService.selectedDiagnoses.length > 0){
                this.selectedDiagnoses = this.patientService.selectedDiagnoses;
            }
        });
    }

    ngAfterViewInit() {

        this.patientSub = this.appService.subscribe('patient', data => {
            if (data['setDiagnosesTop']) {
                this.setDiagnosesTop();
            }

            if (data['selectedDiagnosesAreUpdated']) {
                this.highlightDiagnosesBtns(this.questionnairesComponent.selectedId, data['items']);
                this.selectedDiagnoses = this.patientService.selectedDiagnoses;
            }

            if (data['questionnaireIsReset']) {
                this.diagnosesBtnsAreHighlighted = false;
            }
        });

        window.scrollTo(0, 0);
    }

    ngOnDestroy() {
        this.document.body.classList.remove('bg--white');

        if (this.patientSub) {
            this.patientSub.unsubscribe();
        }

        if (this.patientUpdateSub) {
            this.patientUpdateSub.unsubscribe();
        }

        if (this.symptomMapActionSub) {
            this.symptomMapActionSub.unsubscribe();
        }

        if (this.diagnosesSub) {
            this.diagnosesSub.unsubscribe();
        }

        if (this.paramsSubscription) {
            this.paramsSubscription.unsubscribe();
        }
    }

    setDiagnosesTop(withoutMapMenu?: boolean) {
        // set the top position of the diagnoses
        const diagnosesEl = document.getElementsByClassName('diagnoses')[0] as HTMLElement;
        const tabEl = document.getElementsByClassName('nav-tabs')[0] as HTMLElement;

        if (!diagnosesEl || !tabEl) {
            return;
        }

        // need to hardcode the numbers due to the unavailable heights of the map & the map menu at times
        const mapMenuHeight = withoutMapMenu ? 0 : 100;
        if (!withoutMapMenu) {
            diagnosesEl.style.top = tabEl.clientHeight + mapMenuHeight + 5 + 'px';
        } else {
            diagnosesEl.style.top = tabEl.clientHeight + mapMenuHeight + (740 - mapMenuHeight - diagnosesEl.clientHeight) / 2 + 'px';
        }
    }

    scrollToMap() {
        if (!this.canScroll) {
            return;
        }
        this.canScroll = false;
        const map = document.getElementById('map');
        map.scrollIntoView();
    }

    haveAccessPatient(){
        return (this.authService.isDoctor || this.authService.isMPA || this.authService.isAssistantPlus) &&
                (this.patient['has_permission'] === this.patientService.ACCESSSTATUS.GRANTED);
    }

    openEditPatientFormModal(patentId: number) {
        const params = {
            action: 'update',
            id: patentId,
            title: this.updatePatientHeader,
            url: 'patient/' + patentId,
            component: 'patients'
        };

        this.initForm(params);

        const form = {};
        for (const column in this.patient) {
            if (this.patient.hasOwnProperty(column)) {
                form[column] = {value: this.patient[column], disabled: false};
            }
        }
        if (!this.externalForm) {
            this.externalForm = this.formBuilder.group(form);

            const phoneValidatorPattern = '[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}';
            this.externalForm.controls['email'].setValidators([<any>Validators.pattern(phoneValidatorPattern)]);
            this.externalForm.controls['name'].setValidators([<any>Validators.required, Validators.pattern('[^\\\x5c/]+')]);
            this.externalForm.controls['surname'].setValidators([<any>Validators.required, Validators.pattern('[^\\\x5c/]+')]);
            this.externalForm.controls['assignee_id'].setValidators([<any>Validators.required]);
            // this.externalForm.controls['gender'].setValidators([<any>Validators.required]);
            this.externalForm.controls['entry_date'].setValidators([<any>Validators.required]);
            // this.externalForm.controls['birthday'].setValidators([<any>Validators.required]);

            //1638
            if (this.patient['is_test_patient']) {
                this.externalForm.controls['name'].disable();
                this.externalForm.controls['surname'].disable();
            }
        } else {
            this.externalForm.reset(form);
        }

        if (this.patient['is_test_patient']) {
            this.externalForm.controls['name'].disable();
            this.externalForm.controls['surname'].disable();
        }

        this.externalForm.controls['assignee_id'].disable();
        this.externalForm.controls['creation_date'].disable();

        this.showModal();
    }

    initForm(params: Object): void {
        this.params = params;
        // store the current page to be used later since this.currentPage will be set to 1 when opening the modal
        this.page = this.currentPage;
        // reset errors
        this.resetErrors();
    }

    openSEModal($event: any = null) {
        let diQuestionnaire = null;
        let seQuestionnaire = null;
        let lastestIndex = 0;
        // Check active questionnaire
        if ($event) {
            this.noActiveQuestionnaire();
        }

        if (this.questionnairesComponent.items && this.questionnairesComponent.items.length > 0 ) {
            seQuestionnaire = this.questionnairesComponent.items[lastestIndex];
            diQuestionnaire =  this.questionnairesComponent.items[lastestIndex]['di_questionnaire'];
        }

        if (this.patientsService.canArchiveQuestion(seQuestionnaire, diQuestionnaire, this.patient['latest_action']['template']) && !this._noActiveQuestionnaire) {
            this.formAction = null;
            this.initForm({
                url: 'patient/' + this.id,
                action: 'archive',
                id: this.activeQuestionnaireId,
                title: 'For your information',
                content: 'For repeated Self-Reports, the previous assessment is being archived. However, it can still be edited afterwards.',
                description:  ''
            });
            return this.showArchiveModal();
        }

        let reminder = null;
        let modalTitle = 'Start Self-Evaluation';
        let activeSendReminder = $event && $event.action == 'open_send_reminder' ? true : null;
        if (!this._noActiveQuestionnaire) {
            modalTitle = 'Update Self-Evaluation';
            if (this.patientsService.haveActiveQuestion(seQuestionnaire, diQuestionnaire)) {
                reminder = seQuestionnaire['id'];
            }
        }

        this.router.navigate(['patient/' + this.id + '/questionnaires'],
            {
                queryParams:
                    {
                        modalTitle: modalTitle,
                        disableBack: true,
                        reminder: reminder,
                        activeSendReminder : activeSendReminder
                    }
            }
        );
    }

    showDiagnosisModal(): void {
        this.modalDiagnosis.config.backdrop = true;
        this.modalDiagnosis.config.ignoreBackdropClick = true;
        this.modalDiagnosis.config.keyboard = false;
        this.modalDiagnosis.show();
    }

    hideDiagnosisModal(isDismiss) {
        this.modalDiagnosis.hide();
        if (isDismiss && this.dismissDiagnosis) {
            // check checkbox checked or not
            this.usersService.saveSetting('diagnosis_pop_up_off', 1)
                .subscribe(data => {
                    if (data['success']) {
                        // add to user setting
                        var user = this.authService.user;
                        if (!isNaN(user['settings'].length) && user['settings'].length == 0) {
                            user['settings'] = {
                                diagnosis_pop_up_off: 1
                            };
                        } else {
                            user['settings'].diagnosis_pop_up_off = 1;
                        }
                        this.authService.saveToLocalStorage(user.email, user);
                    }
                });
        }
    }

    gotoCV() {
        this.patientService.symptomMapAction.next({ action : this.patientService.ACTION.cv_map });
        this.hideDiagnosisModal(true);
    }


    // display modal
    showArchiveModal(): void {
        // prevent users from clicking outside to close the modal since that does not set the url correctly
        if(!this.showArchiveMessageFuture){
            this.archiveQuestionnaires();
            return;
        }
        this.modalArchive.config.backdrop = false;
        this.modalArchive.config.ignoreBackdropClick = true;
        this.modalArchive.config.keyboard = false;
        // this ensures the form is displayed only when the data is ready
        if (this.params['action'] !== 'delete' && this.params['action'] !== 'activate') {
            // if the form opened belongs to the component different from the component where it's opened
            if (this.params['component'] != null) {
                this.externalFormLoading = false;
            } else {
                this.formLoading = false;
            }
        }
        // hide the app loading icon
        this.isLoading = false;
        this.isUpdated = false;
        this.resetErrors();
        this.modalArchive.show();
    }

    // hide modal when clicking Cancel
    hideArchiveModal(isUpdated?: boolean) {
        this.modalArchive.hide();

        // unsubscribe subscription to avoid memory leaks & prevent this.modal.onHidden() being called repeatedly
        if (typeof this.modalHidingSub !== 'undefined') {
            this.modalHidingSub.unsubscribe();
        }

        this.modalHidingSub = this.modalArchive.onHidden.subscribe(() => {
            this.modalIsClosed = true;
            this.isLoading = false;
            this.formSubmitted = false;
            this.responseMessage = null;
            this.fullPath = '';

            if (isUpdated) {
                this.isUpdated = isUpdated;
                this._noActiveQuestionnaire = true;
                this.triggerOpenSRModal = true;
            }

            // unsubscribe subscription to avoid memory leaks & prevent undesired behaviours such as disabled form fields getting enabled
            if (typeof this.sub !== 'undefined') {
                this.sub.unsubscribe();
            }
        });
    }

    archiveQuestionnaires() {
        if (!this.activeQuestionnaireId) {
            return false;
        }
        this.isLoading = true;
        const showInFuture = this.showArchiveMessageFuture ? 1 : 0;
        this.questionnairesService.archiveQuestionnaires(this.activeQuestionnaireId, showInFuture).pipe(
            finalize(() => this.isLoading = false))
            .subscribe(
                response => {
                    const message = response['message'];
                    this.isUpdated = true;
                    this.authService.setData('show_confirm_archive_self_report_modal', showInFuture);

                    this.hideArchiveModal(true);
                    this._noActiveQuestionnaire = true;
                    this.triggerOpenSRModal = true;
                    // disable the selected diagnosis additions/removals
                    this.patientService.questionnaireIsArchived = true;

                    if (message !== 'undefined' && message !== '') {
                        this.responseMessage = message;
                        return;
                    }
                },
                error => {
                    this.isLoading = false;
                    this.errorMessage = this.appService.parseErrors(error);
                }
            );
    }

    /**
     * Update URL for refresh
     */
    navigateWithParams(patientId = null) {
        // set url query parameters
        this.router.navigateByUrl(this.url + '/' + patientId);
    }
    loadData() {
        // display app loading icon
        this.isLoading = true;
        // call api to get data
        this.patientsService.profile(this.id).subscribe(data => {
            this.initData = true;
            this.doctors = data['doctors'];
            this.assistants = data['assistants'];
            this.mpa = data['mpa'];
            this.patient = data['patient'];
            this.questionnaires = data['questionnaires'];
            this.questionnaireCount = data['questionnaireCount'];
            this.diagnoses = data['diagnoses'];
            this.selectedDiagnoses = data['selected_diagnoses'];
            this.seCompletedDates = data['se_completed_dates'];
            this.diCompletedDates = data['di_completed_dates'];
            this.completedDates = data['completed_dates'];
            this.isViewOnly = data['is_view_only'];
            this.languages = data['languages'];
            this.documents = data['download_files'];
            // Set selected diagnosis
            this.patientService.diagnoses = data['diagnoses'];
            this.patientService.selectedDiagnoses = data['selected_diagnoses'];
            this.patientService.enableProposal = data['patient']['clinic']['show_proposal_diagnosis'];
            this.isShowPatientDocument = data['patient']['clinic']['show_patient_document'];
            this.isShowPatientServiceProvider = data['patient']['clinic']['show_patient_service_provider'];
            this.isShowPatientVideoCall = data['patient']['clinic']['show_patient_video_call'];

            // set helpTemplates
            this.popoverService.setHelpContent(data['helpTemplates']);

            // If patient don't have questionnaires => hide loading
            if (this.questionnaireCount === 0) {
                this.isLoading = false;
            }

            // Open SR Modal after archive questionnaire
            if (this.triggerOpenSRModal) {
                this.openSEModal();
                this.triggerOpenSRModal = false;
            }

            this.selectLatestTab();
        });
    }

    hideModal(isUpdated?: boolean) {
        this.modal.hide();

        // unsubscribe subscription to avoid memory leaks & prevent this.modal.onHidden() being called repeatedly
        if (typeof this.modalHidingSub !== 'undefined') {
            this.modalHidingSub.unsubscribe();
        }

        this.modalHidingSub = this.modal.onHidden.subscribe(() => {
            this.formSubmitted = false;
            this.responseMessage = null;
            this.loadData();
        });
    }

    selectLatestTab() {
        // Select map to show when first load
        this.questionnaireData = this.questionnaires[0];

        // Limit get Diagnosis data for only some Specific tab
        this.getDiagnosisData = this.tabWithDiagnosis.indexOf(this.patientService.activeTab) >= 0 ? true : false;
        // In case user select old questionnaire -> get latest data of questionnaire and reload the map
        if (this.selectedQuestionnaire) {
            this.questionnaires.forEach(questionnaire => {
                if (questionnaire['id'] === this.selectedQuestionnaire['id']) {
                    this.selectedQuestionnaire = questionnaire;
                }
            });

            if (this.patientService.activeTab === this.TABHEADER.SR) {
                this.seMap.selectedCurrentId = this.selectedQuestionnaire['id'];
                this.seMap.isMapVisible = false;
                this.seMap.onSelect();
            } else if (this.patientService.activeTab != this.TABHEADER.OVERVIEW) {
                this.diMap.selectedCurrentId = this.selectedQuestionnaire['di_questionnaire']['id'];
                this.diMap.isMapVisible = false;
                this.diMap.onSelect();
            }
            return;
        }

        if (this.seCompletedDates.length && !this.diCompletedDates.length) {
            this.seMap.selectedCurrentId = this.seCompletedDates[0].id;
            this.seMap.isMapVisible = false;
            return this.seMap.onSelect();
        }

        if (!this.seCompletedDates.length && this.diCompletedDates.length) {
            this.diMap.selectedCurrentId = this.diCompletedDates[0].id;
            this.diMap.isMapVisible = false;
            return this.diMap.onSelect();
        }

        if (this.seCompletedDates.length && this.diCompletedDates.length) {
            if (this.seCompletedDates[0].id < this.diCompletedDates[0].id) {
                this.diMap.selectedCurrentId = this.diCompletedDates[0].id;
                this.diMap.isMapVisible = false;
                return this.diMap.onSelect();
            } else {
                this.seMap.selectedCurrentId = this.seCompletedDates[0].id;
                this.seMap.isMapVisible = false;
                return this.seMap.onSelect();
            }
        }

        if (this.questionnaires.length > 0) {
            this.seMap.selectedCurrentId = this.questionnaires[0].id;
            this.seMap.isMapVisible = false;
            return this.seMap.onSelect();
        }
    }

    setSelectedDateOnTab(selectedMapType: string, date: string) {
        if (selectedMapType === 'SE') {
            this.selectedSEDate = date;
            this.selectedDIDate = '';
        } else if (selectedMapType === 'DI') {
            this.selectedSEDate = '';
            this.selectedDIDate = date;
        } else {
            this.selectedDIDate = '';
            this.selectedSEDate = '';
        }
    }

    /*
        get the questionnaire id that corresponds with the currently selected Id
        e.g. if a SE questionnaire is currently selected, the DI questionnaire related to it should be selected
        when clicking the DI tab and vice versa
    */
    setCorrespondingQuestionnaireId(selectedMapType: string) {
        if (selectedMapType === 'SE') {
            for (let i = 0; i < this.questionnaires.length; i++) {
                if (this.questionnaires[i].type === 'se' && this.questionnaires[i].di_questionnaire.id === this.questionnairesComponent.selectedId) {
                    this.seMap.selectedCurrentId = this.questionnaires[i].id;
                    let date = this.getFormattedDateForTab(this.questionnaires[i]);
                    this.setSelectedDateOnTab('SE', date);
                    break;
                } else if (this.questionnaires[i].type === 'di' && this.questionnaires[i].id === this.questionnairesComponent.selectedId) {
                    this.seMap.selectedCurrentId = 0;
                    this.setSelectedDateOnTab('', '');
                    break;
                }
            }
        } else {
            for (let i = 0; i < this.questionnaires.length; i++) {
                if (this.questionnaires[i].type === 'se' && this.questionnaires[i].id === this.questionnairesComponent.selectedId) {
                    this.diMap.selectedCurrentId = this.questionnaires[i].di_questionnaire.id;
                    let date = this.getFormattedDateForTab(this.questionnaires[i].di_questionnaire);
                    this.setSelectedDateOnTab('DI', date);
                    break;
                }
            }
        }
    }

    // hightlight diagnoses toggle & diagnosis addition button
    highlightDiagnosesBtns(id: number, items) {
        const latestQuestionnaire = this.questionnaires[0];
        let isSE = false;
        if (latestQuestionnaire.type === 'se') {
            isSE = true;
        }
        if (items && latestQuestionnaire.archived) {
            if (isSE) {
                this.questionnaires[0]['di_questionnaire']['diagnoses'] = items;
            } else {
                this.questionnaires[0]['diagnoses'] = items;
            }
        }

        if (latestQuestionnaire
            && (
                (latestQuestionnaire.type === 'se'
                    && !latestQuestionnaire.di_questionnaire.archived
                    && latestQuestionnaire.di_questionnaire.completed_date
                    && latestQuestionnaire.diagnoses?.length < 1)
                || (latestQuestionnaire.type === 'di'
                    && !latestQuestionnaire.archived
                    && latestQuestionnaire.completed_date
                    && latestQuestionnaire.diagnoses?.length < 1)
            )) {
            // && this.patientService.selectedDiagnoses.length < 1) {
            this.diagnosesBtnsAreHighlighted = true;
        } else {
            this.diagnosesBtnsAreHighlighted = false;
        }
    }

    /**
     * @param patientFormData
     * @param isValid
     */
    savePatient(patientFormData, isValid, createSE?: boolean) {
        if (!isValid) {
            this.formSubmitted = true;
            return;
        }

        this.resetErrors();

        /**
         * Manipulate date from date selector component
         * @type {moment.Moment}
         */
        let formattedBirthday = moment();
        if (patientFormData.birthday) {
            formattedBirthday = moment({
                year: patientFormData.birthday.date.year,
                month: patientFormData.birthday.date.month - 1, // http://momentjs.com/docs/#/get-set/month/
                day: patientFormData.birthday.date.day,
            });
            patientFormData['birthday'] = formattedBirthday.format(this.dateFormat);
            this.patient['birthday'] = formattedBirthday.format(this.dateFormat);
        } else {
            patientFormData['birthday'] = '';
        }


        let formattedEntryDate = moment({
            year: patientFormData.entry_date.date.year,
            month: patientFormData.entry_date.date.month - 1,
            day: patientFormData.entry_date.date.day,
        });


        patientFormData["entry_date"] = formattedEntryDate.format(this.dateFormat);

        this.patient['language_id'] = patientFormData.language_id;
        const patientId = this.id;

        // Update to backend
        this.baseService.submit('patients', patientFormData.id, patientFormData).subscribe(
            response => {
                this.successMessage = response['message'];
                const _self = this;
                setTimeout(() => {
                    _self.successMessage = '';
                    _self.hideModal();
                    if (createSE) {
                        _self.router.navigate(['patient/' + patientId + '/questionnaires/'], {queryParams: {modalTitle: 'Start Self-Evaluation'}});
                    }
                }, 1000);
            },
            err => {
                this.errorMessage = this.appService.parseErrors(err);
                patientFormData.birthday = formattedBirthday;
                patientFormData.entry_date = formattedEntryDate;
            }
        );
    }

    /**
     * @param patientFormData
     * @param isValid
     */
    savePatientWithSE(patientFormData, isValid) {
        return this.savePatient(patientFormData, isValid, true);
    }

    openLocalInterview(type: string) {
        const next3Days = moment().add(3, 'days');

        const model = {
            id: null,
            patient_id: this.id,
            questionnaire_type_id: type,
            token: null,
            answer_method: 'local',
            email: null,
            due_date: {
                date: {
                    year: next3Days.format('Y'),
                    month: next3Days.format('M'),
                    day: next3Days.format('D'),
                }
            },
            template_translation_id: null,
            content: ''
        };

        this.isLoading = true;

        this.baseService.submit('patient/save-questionnaire', this.id, model).pipe(
            finalize(() => this.isLoading = false))
            .subscribe(response => {
                    // Log off and redirect to questionnaire link if On Local Device selected
                    if (response['token'] !== '') {
                        localStorage.setItem('openSE', JSON.stringify(true));
                        let link = response['local_questionnaire_link'];
                        if (response['questionnaire_type'] === 'di') {
                            link += `?id=${this.id}`;
                        }
                        window.location.href = link;
                    }
                },
                error => {
                    this.errorMessage = this.appService.parseErrors(error);
                    this.openAlertModal({icon: 'fas fa-exclamation-triangle', warning: true}, this.errorMessage);
                }
            );
    }


    openAlertModal(params: Object, errorMessage: any) {
        const dialog = this.dialog.openAlert(params);
        dialog.onSubmit(() => {
            return;
        });

        dialog.showAlert(errorMessage[0]);
    }

    disableDiagnoses(event) {
        this.diagnosesAreDisabled = event;

        if (this.diagnosesAreDisabled) {
            this.collapseDiagnoses = true;
            this.patientService.newDiagnoses = [];
        }
    }

    updateQuestionnaires(questionnaires) {
        this.questionnaires = questionnaires;
        this.questionnaireCount = this.questionnaires.length;

        // reset the selected questionnaire id after deleting the only questionnaire
        if (this.questionnaireCount === 0) {
            this.questionnairesComponent.selectedId = 0;
        } else {
            let selectedIdIsFound = false;
            for (let questionnaire of this.questionnaires) {
                if (questionnaire['id'] === this.questionnairesComponent.selectedId
                    || (questionnaire['di_questionnaire'] && questionnaire['di_questionnaire'].id === this.questionnairesComponent.selectedId)) {
                    selectedIdIsFound = true;
                    break;
                }
            }

            if (!selectedIdIsFound) {
                this.questionnairesComponent.selectedId = this.questionnaires[0].id;
            }
        }
    }

    getFormattedDateForTab(questionnaire) {
        if (questionnaire.archived && questionnaire.completed_date) {
            return moment(questionnaire.completed_date).format(this.dateFormat);
        } else {
            return moment(questionnaire.updated_at).format(this.dateFormat);
        }
    }

    enableComparison($event) {
        this.comparisonMode = $event;
    }

    exportMap($event) {
        if(this.selectedSymptomMap === 'SE'){
            return this.seMap.exportLatestMap(this.questionnairesComponent.selectedId);
        }
        this.diMap.exportLatestMap(this.questionnairesComponent.selectedId);
    }

    openDI() {
        this.enableEditMode({ questionnaire : this.questionnaireData, type : this.selectedSymptomMap });
    }

    initModalForm(params: Object): void {
        const queryParams = {};

        for (const param in params) {
            if (param !== 'url' && params.hasOwnProperty(param)) {
                queryParams[param] = params[param];
            }
        }
        // reset errors
        this.resetErrors();

        // Notice: For popup navitation from the search on StartPage
        this.router.navigate([params['url']], { queryParams: queryParams });

        // display app loading icon
        this.isLoading = true;
    }

    selectMap(value) {
        let map = value == 'DI' ? this.diMap : this.seMap;
        this.collapseDiagnoses = true;
        this.selectedSymptomMap = value;
        this.patientService.displaySelectedDiagnosisPlaceholder = false;
        map.onSelect();
        this.setCorrespondingQuestionnaireId(value);
    }

    openProposalDiagnosis(proposal){
        this.triggerOpenProposalDiagnosis = true;
        //Need time to render proposal diagnosis
        setTimeout(() => {
            this.appService.publish('diagnoses', { selectedDiagnosesToEdit: true, diagnosis: proposal ? proposal.diagnoses : null });
        }, 200);
    }

    enableEditMode(params) {

        const questionnaire = params.questionnaire;

        if (questionnaire.step === 5) {
            this.isLoading = true;
            this.questionnairesService.openQuestionnaireEditMode(questionnaire.di_questionnaire.id, 'di').subscribe( (res) => {
                this.patientService.symptomMapAction.next({ 'action' : this.patientService.ACTION.edit_mode});
                this.loadData();
                // Reload interactive map
                if (this.diMap && this.diMap.interactiveMapComponent) {
                    this.loadData();
                    this.diMap.interactiveMapComponent.initInteractiveMap();
                }
            });
            return;
        }

        let confirmDialog = this.dialog.openConfirm({
            icon: 'fas fa-exclamation-triangle',
            content: 'The started Self Evaluation will be archived by opening the Diagnostic Interview and is thus not further editable!',
            submitText: 'Continue anyway?'
        });

        confirmDialog.onSubmit(() => {
            this.isLoading = true;
            this.questionnairesService.openQuestionnaireEditMode(questionnaire.di_questionnaire.id, 'di').subscribe( (res) => {
                confirmDialog.hideModal();
                this.patientService.symptomMapAction.next({ 'action' : this.patientService.ACTION.edit_mode});
                this.loadData();
                // Reload interactive map
                if (this.diMap && this.diMap.interactiveMapComponent) {
                    this.loadData();
                    this.diMap.interactiveMapComponent.initInteractiveMap();
                }
            });
        });

        confirmDialog.onCancel(() => {
            // In the case cancel clone data -> go to CV tab with empty map
            this.diMap.selectedCurrentId = this.selectedQuestionnaire ? this.selectedQuestionnaire['di_questionnaire']['id'] : this.questionnaireData['di_questionnaire']['id'];
            this.diMap.isMapVisible = true;
            this.diMap.onSelect();
            this.diMap.openInteractiveMap();
        });
    }

    autoGenerateReport(document){
        this.documents.push(document);
        this.appService.isLoading = false;
        return this.selectTabHeader(this.TABHEADER.DOCUMENTS);
    }

    selectTabHeader(tabId: number) {
        this.patientService.activeTab = tabId;
        this.closeMap();
        // Limit get Diagnosis data for only some Specific tab
        this.getDiagnosisData = this.tabWithDiagnosis.indexOf(tabId) >= 0 ? true : false;

        if (!this.questionnaireData) {
            return;
        }

        if (tabId === this.TABHEADER.OVERVIEW) {
            if (this.haveNewData) {
                this.haveNewData = false;
                return this.loadData();
            }
            this.selectedQuestionnaire = null;
            this.diMap.isMapVisible = true;
            this.seMap.isMapVisible = true;
        }

        let questionnaireData = this.selectedQuestionnaire ? this.selectedQuestionnaire : this.questionnaireData;

        if (tabId === this.TABHEADER.SR) {
            this.seMap.selectedCurrentId = questionnaireData['id'];
            this.seMap.isMapVisible = true;
            this.seMap.viewMode = true;
            this.seMap.onSelect();
        }

        if (tabId === this.TABHEADER.CV) {
            if (questionnaireData['step'] >= 4 && questionnaireData['di_questionnaire']['step'] === 0) {
                return this.enableEditMode({ questionnaire : questionnaireData, type : this.selectedSymptomMap});
            }
            this.diMap.selectedCurrentId = questionnaireData['di_questionnaire']['id'];
            this.diMap.isMapVisible = true;
            this.diMap.onSelect();
            this.diMap.openInteractiveMap();

            // Bug 7063 -- Need to calculate tasklist when open map
            if (this.diMap.interactiveMapComponent && this.diMap.interactiveMapComponent.mapData && this.diMap.interactiveMapComponent.mapData.domain) {
                this.diMap.interactiveMapComponent.countingTasklist();
            }
        }

        if (tabId === this.TABHEADER.PROPOSALS) {
            this.diMap.selectedCurrentId = questionnaireData['di_questionnaire']['id'];
            this.diMap.isMapVisible = true;
            this.diMap.onSelect();
            this.diMap.openProposalMap();
        }
    }

    closeMap() {
        this.seMap.closeInteractive(false);
        this.diMap.closeInteractive(false);
        this.diMap.closeProposalDiagnosis(false);
        this.seMap.openComparison = false;
        this.diMap.openComparison = false;
        this.triggerOpenProposalDiagnosis = false;
    }

    getItems() {
        this.isLoading = false;
        return this.loadData();
    }

    fileChangeEvent(fileInput: any) {
        if (fileInput.target.files && fileInput.target.files[0]) {
            // Size Filter Bytes (128 Mb)
            const max_size = 128000000;
            const allowed_types = ['application/pdf'];

            if (fileInput.target.files[0].size > max_size) {
                this.documentError =
                    'Maximum size allowed is ' + max_size / 1000000 + 'Mb';

                return false;
            }

            if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
                this.documentError = 'Only PDF are allowed ( .pdf )';
                return false;
            }
            const reader = new FileReader();
            reader.onload = (e: any) => {
                // create FormData
                const formData: FormData = new FormData();
                formData.append('filename', 'test');
                formData.append('blob', fileInput.target.files[0]);

                this.patientService.upload(this.id, formData).subscribe(
                    response => {
                        this.successMessage = response['message'];
                        this.documents.push(response['file']);
                    });
            };
            reader.readAsDataURL(fileInput.target.files[0]);
        }
    }

    documentConfirmModal(params: Object) {
        this.initForm(params);

        // close the modal opened before the confirmation modal
        if (this.modal && this.modal.isShown) {
            this.hideModal();
        }

        if(!this.dialog){
            return;
        }
        const dialog = this.dialog.openConfirm(params);
        this.isLoading = false;

        dialog.onSubmit(() => {
            this.isLoading = true;

            const url = (params['component'] ? params['component'] : params['url']) + '/' + params['action'] + '/' + params['id'];

            this.baseService.changeStatus(url, params['action'])
                .subscribe(
                    response => {
                        this.isUpdated = true;
                        this.isLoading = false;
                        if(response['success']){
                            _.remove(this.documents, function(item){
                                return item['id'] === params['id'];
                            });
                        }

                        const message = response['message'];
                        if (message) {
                            dialog.showAlert(message);
                        }
                    },
                    error => {
                        dialog.showAlert(error.error.error);
                        this.isLoading = false;
                    }
                );
        });

        dialog.onCancel(() => {
            if (this.modal && this.modal.isShown) {
                this.hideModal();
            }
        });
    }

    dowloadDocument(pdf) {
        this.documentsService.download(pdf.id)
        .subscribe(data => {
            saveAs(data['body'], pdf['original_file_name']);
        });
    }


    requestAccessHealthData(patient) {
        const action = patient['has_permission'] === this.patientService.ACCESSSTATUS.GRANTED ? 'revoke' : 'request';
        const content = action === 'revoke' ? 'Do you want to revoke all access to see health data of the patient?' : 'Do you want to request access to see health data of the patient?';
        let confirmDialog = this.dialog.openConfirm({
            icon: 'fas fa-exclamation-triangle',
            content: content,
            submitText: 'Continue anyway?'
        });
        confirmDialog.onSubmit(() => {
            this.isLoading = true;
            const alert = this.dialog.openAlert({icon: 'fas fa-exclamation-triangle'});
            this.patientService.requestPermissionHealthData(patient).subscribe((res) => {
                this.appService.isLoading = false;
                alert.showAlert(res['message']);
                patient['has_permission'] = action === 'revoke' ?  this.patientService.ACCESSSTATUS.NOACCESS:  this.patientService.ACCESSSTATUS.PENDING;
            },
            error => {
                alert.showAlert(error.error.error);
                this.appService.isLoading = false;
            });
        });

        confirmDialog.onCancel(() => {
            // In the case cancel clone data -> go to CV tab with empty map
        });
    }
}
